































import { SysDictData } from '@/types/api-beans';
import { get } from '@/utils/dict';
import Vue from 'vue';

export default Vue.extend({
  name: 'DictSelect',
  props: {
    type: { type: String, required: true},
    value: {}
  },
  data() {
    return {
      // @ts-ignore
      localValue: this.value?.toString() ?? null,
      list: [] as SysDictData[]
    };
  },
  watch: {
    value: {
      handler(v) {
        if (this.type === 'car_license_type') {
          let val:any = this.value;
          if (val && !isNaN(val)) {
            this.localValue = v?.toString();
            this.$emit('input', this.localValue);
          }else {
            const newArr = this.list.filter(el=>{
              return el.dictLabel === val;
            });
            if (newArr && newArr.length) {
              this.localValue =  newArr[0].dictValue?.toString();
              this.$emit('input', this.localValue);
            }else {
              this.localValue = v;
              this.$emit('input', this.localValue);
            }
          }
        }else if(this.type==='crash_position' ||
        this.type==='accident_situation' ||
        this.type==='collision_type') {
            this.localValue = v;
        }else {
          this.localValue = v?.toString();
        }
      },
      immediate:true,
      deep:true
    },
    localValue(v) {
      this.$emit('input', v);
    }
  },
  async created() {
    let list = await get(this.type);
    if (this.type==='crash_position' ||
    this.type==='accident_situation' ||
    this.type==='collision_type') {
      list.map(el => {
        if ((el.dictLabel === '其他' || el.dictLabel === '其它') && el.dictValue !== '99') {
          el.dictValue = '99';
        }else {
          if ((el.dictValue as any).length > 1 && (el.dictValue as any)[0] === '0') {
            // console.log(el.dictValue);
          }else {
            el.dictValue = '0' + el.dictValue;
          }
        }
      });
    }
    this.list = list;
  }
});
